import React from 'react'
import { Button, Box } from '@mui/material'
import { SaveAlt, UploadFile } from '@mui/icons-material'

const ImportExport = ({ data, selectableColumns }) => {
  const generateCSV = () => {
    let csvText = ''

    const rowCount = data.length
    const [ticketCount, taskCount] = data.reduce(
      (acc, item) => {
        return [
          acc[0] + item.tickets?.length || 0,
          acc[1] + item.tasks?.length || 0,
        ]
      },
      [0, 0]
    )

    selectableColumns.forEach((c, i) => {
      csvText += c.label

      csvText += i === selectableColumns.length - 1 ? '\r\n' : ','
    })

    csvText += `Rows: ${rowCount}, Tickets: ${ticketCount}, Tasks: ${taskCount}\n\n`

    data.forEach((d) => {
      selectableColumns.forEach((c, i) => {
        const val = d[c.key]

        if (c.getExport) {
          csvText += c.getExport(d)
        } else {
          csvText += `"${val || ''}"`
        }

        csvText += i === selectableColumns.length - 1 ? '' : ','
      })
      csvText += '\n'
    })

    return csvText
  }

  const downloadCsv = (csvContent) => {
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })

    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, csvFileName) // IE 10+
    } else {
      const link = document.createElement('a')
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob)
        link.setAttribute('href', url)
        link.setAttribute('download', 'startupCRM-export.csv')
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    }
  }

  const generateAndDownloadCsv = () => downloadCsv(generateCSV())

  return (
    <Box>
      <Button onClick={generateAndDownloadCsv} endIcon={<SaveAlt />}>
        Export
      </Button>
    </Box>
  )
}

export default ImportExport
